import type { LenusCookieConsentConfig } from '#src/assets/lib/config/types.ts'

const cookieConsentApiUrl = 'https://api.cookies.lenus.io'
const cookieConsentCdnUrl = 'https://cookies.lenus.io'
const defaultLocale = 'en'

const ERROR_PREFIX = '[Lenus Cookie Consent]'

function getScriptTag(): HTMLScriptElement | null {
  return document.currentScript instanceof HTMLScriptElement
    ? document.currentScript
    : null
}

export function resolveConfig(): LenusCookieConsentConfig {
  const scriptTag = getScriptTag()

  return {
    apiBaseUrl:
      scriptTag?.getAttribute('data-api-url') ||
      window.LENUS_COOKIE_CONSENT_API_URL ||
      cookieConsentApiUrl,
    siteId:
      scriptTag?.getAttribute('data-site-id') ||
      window.LENUS_COOKIE_CONSENT_SITE_ID ||
      '',
    locale:
      scriptTag?.getAttribute('data-locale') ||
      document.documentElement.lang ||
      defaultLocale,
    cdnUrl:
      scriptTag?.getAttribute('data-cdn-url') ||
      window.LENUS_COOKIE_CONSENT_CDN_URL ||
      cookieConsentCdnUrl,
    debug: scriptTag?.getAttribute('data-debug') === 'true' || false,
  }
}

export function validateConfig(
  config: LenusCookieConsentConfig,
): LenusCookieConsentConfig {
  if (!config.apiBaseUrl) {
    console.error(`${ERROR_PREFIX} Missing required data-api-url attribute`)
    throw new Error('Missing required data-api-url attribute')
  }

  if (!config.siteId) {
    console.error(`${ERROR_PREFIX} Missing required data-site-id attribute`)
    throw new Error('Missing required data-site-id attribute')
  }

  return config
}

export const configDefaults = { defaultLocale }
